import { getMessagingInstance } from "./firebase";


export const getFcmToken = async () => {
  try {
    const messaging = getMessagingInstance();

    if (!messaging) {
      console.log("Messaging not initialized");
      return null;
    }

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BBEnA01q9AB3ij1cmQlaZxKm2iKoKZYSyhndXQ6r04NvaBJ8iVZXegYirxvNsOWdfYaau4jbX8-d5ukMmIdB39Q"
    });

    console.log("FCM TOKEN:", token);

    return token;

  } catch (error) {
    console.log("FCM error", error);
  }
};